// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1GiHc","inner":"Footer_inner__3PFuD"};